import { render } from "./ShowMore.vue?vue&type=template&id=474b5d5e&scoped=true"
import script from "./ShowMore.vue?vue&type=script&lang=js"
export * from "./ShowMore.vue?vue&type=script&lang=js"

import "./ShowMore.vue?vue&type=style&index=0&id=474b5d5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-474b5d5e"

export default script